import { MenuScheduleSettings } from "./schedule/menu.schedule.model";
import { MenuDetailsSettings } from "./details/menu.details.model";
import { MenuPaymentSettings } from "./payment/menu.payment.model";
import { MenuBuilder } from "./menu.builder";
import { MenuDrink } from "./drink/menu.drink.model";
import { MenuCategory } from "./category/menu.category.model";

//Readonly Version of Menu
export class Menu {
  public readonly isActive: boolean;
  public readonly details: MenuDetailsSettings;
  public readonly payments: MenuPaymentSettings;
  public readonly schedule: MenuScheduleSettings;

  public drinks: MenuDrink[];
  public categories: MenuCategory[];
  constructor(builder: MenuBuilder) {
    this.isActive = builder.isActive;
    this.details = builder.details.build();
    this.payments = builder.payments.build();
    this.schedule = builder.schedule.build();
  }

  public loadDrinks(drinks: MenuDrink[]): void {
    //TODO: LOAD THE DRINKS
    //TODO: UPDATE THE MAP
  }

  public loadCategories(categories: MenuCategory[]) {
    //TODO: LOAD THE CATEGORIES
    //TODO: UPDATE THE MAP
  }
}
